/*
 * 文件EN: clientClue.js,
 * 文件CN: T8客户线索,

 */

import * as Models from '@/api/T8/clientClue'

export default {
  namespaced: true,
  actions: {
    // 获取列表
    async getList(ctx, payload) {
      return await Models.getListData(payload).then(res => {
        // return (res && res.status === 200 && res.data) && Promise.resolve(res.data) || Promise.reject(`data: ${null}`)
        return (res && res.status === 200 && res.data)
      })
    },
    async getDetail(ctx, payload) {
      return await Models.getDetail(payload).then(res => {
        return (res && res.status === 200 && res.data)
      })
    },
    async changeMer(ctx, payload) {
      return await Models.changeMer(payload).then(res => {
        return (res && res.status === 200 && res)
      })
    },
    async recordMer(ctx, payload) {
      return await Models.recordMer(payload).then(res => {
        return (res && res.status === 200 && res)
      })
    },



  }
}
